/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DnR API
 * 地方自治体事業管理システムAPI
 * OpenAPI spec version: 1.0.0
 */

/**
 * EUC取り込みエラーチェックステータス
 */
export type EucImportValidateStatus =
  (typeof EucImportValidateStatus)[keyof typeof EucImportValidateStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EucImportValidateStatus = {
  success: 'success',
  failed: 'failed',
} as const;
